import { render } from "./SecondOpinionResponse.vue?vue&type=template&id=df007568&scoped=true&ts=true"
import script from "./SecondOpinionResponse.vue?vue&type=script&lang=ts"
export * from "./SecondOpinionResponse.vue?vue&type=script&lang=ts"

import "./SecondOpinionResponse.vue?vue&type=style&index=0&id=df007568&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df007568"]])

export default __exports__